import React from 'react';
import { StyledContent } from './HomeStyles';
import './HomeTranslate';
import HomeInsert from './section/HomeInsert';
import HomeServices from './section/HomeServices';
import { getContentWidth } from '../../utils/getContentWidth';
import NotificationHome from './NotificationHome';

function Home() {
  const contentWidth = getContentWidth('/kindergarten-services');

  return (
    <div style={{ width: '100%' }}>
      <StyledContent>
        <HomeInsert contentWidth={contentWidth} />
      </StyledContent>
      <HomeServices contentWidth={contentWidth} />
      <NotificationHome />
    </div>
  );
}

export default Home;
